import { useEconomyStore } from '@/state/useEconomyStore'
import { useShipStore } from '@/state/useShipStore'
import { useCombatStore } from '@/state/useCombatStore'
import { WEAPONS } from '@/combat/weaponTypes'
import { ITEM_DISPLAY_NAMES } from '@/economy/types'
import './InventoryHUD.css'

export function InventoryHUD() {
  const aboard = useShipStore((s) => s.aboard)
  const wallet = useEconomyStore((s) => s.wallet)
  const equippedWeapon = useCombatStore((s) => s.equippedWeapon)

  // Hide when aboard a ship (ShipHUD takes the bottom-left)
  if (aboard) return null

  const weaponInfo = WEAPONS[equippedWeapon]
  const cargo = wallet?.cargo ?? []
  const totalItems = cargo.reduce((s, [, q]) => s + q, 0)

  return (
    <div className="inv-hud">
      {/* Wallet */}
      {wallet && (
        <div className="inv-hud__wallet">
          <span className="inv-hud__follis">{wallet.follis.toLocaleString()}ƒ</span>
          {wallet.solidus > 0 && (
            <span className="inv-hud__solidus">{wallet.solidus.toLocaleString()}s</span>
          )}
        </div>
      )}

      {/* Equipped weapon */}
      <div className="inv-hud__weapon">
        <div className="inv-hud__weapon-label">Equipped</div>
        <div className="inv-hud__weapon-name">{weaponInfo.name}</div>
      </div>

      {/* Cargo */}
      <div className="inv-hud__cargo">
        <div className="inv-hud__cargo-header">
          <span className="inv-hud__cargo-title">Cargo</span>
          {totalItems > 0 && (
            <span className="inv-hud__cargo-count">{totalItems}</span>
          )}
        </div>

        {cargo.length === 0 ? (
          <div className="inv-hud__empty">Empty</div>
        ) : (
          <div className="inv-hud__items">
            {cargo.map(([item, qty]) => (
              <div key={item} className="inv-hud__item">
                <span className="inv-hud__item-name">
                  {ITEM_DISPLAY_NAMES[item]}
                </span>
                <span className="inv-hud__item-qty">{qty}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
